import { PropertyType } from '__generated__/athena';

import { GeoPoint } from '../map/types';
import { RangeOption } from './types';

/**
 * For use with Dropdown values and options to prevent invalid states in filter ranges
 *
 * @param options a list of RangeOptions for a Dropdown
 * @param op whether options should be accepted above or below the limit
 * @param limit a stringified integer representing the limit
 * @returns the filtered list of RangeOptionsZ
 */
export const filterIntOptions = (
  options: RangeOption[],
  op: 'gt' | 'lt',
  limit?: string,
): RangeOption[] => {
  if (!limit) {
    return options.slice();
  }

  const limitVal = parseInt(limit, 10);
  if (isNaN(limitVal)) {
    return options.slice();
  }

  return options.filter((option) => {
    const val = parseInt(option.value, 10);
    if (op === 'gt') {
      return val > limitVal;
    }

    return val < limitVal;
  });
};

export enum MapSearchZoom {
  CITY = 9,
  ZIP = 11,
  NEIGHBORHOOD = 13,
}

// Based on API limits
export const MAX_MARKETS = 150;

// Fallback market when none specified or invalid
export const DEFAULT_MARKET = 'PHOENIX';

export const getZoomForLocationType = (zoneType?: string): number => {
  if (zoneType === '(Zip code)') {
    return MapSearchZoom.ZIP;
  }
  if (zoneType === '(Neighborhood)') {
    return MapSearchZoom.NEIGHBORHOOD;
  }
  return MapSearchZoom.CITY;
};

/**
 * Convert GeoJSON polygon coordinates to GeoPoint format
 */
export const convertToGeoPointVertices = (vertices: number[][][]): GeoPoint[][] => {
  return vertices?.map((polygon) => polygon.map(([lon, lat]) => ({ lon, lat }))) ?? [];
};

export const buildPropertyTypes = (
  singleFamily?: boolean | null,
  condo?: boolean | null,
  townhome?: boolean | null,
): PropertyType[] => {
  const propertyTypes: PropertyType[] = [];

  if (singleFamily) {
    propertyTypes.push('HOUSE' as PropertyType);
  }
  if (condo) {
    propertyTypes.push('CONDO' as PropertyType);
  }
  if (townhome) {
    propertyTypes.push('TOWNHOUSE' as PropertyType);
  }

  return propertyTypes;
};
